import React, { useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import TicketRequests from "services/tickets";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import TicketsTable from "./TicketsTable";


const useStyles = makeStyles((theme) => ({
    cardRoot: {
        [theme.breakpoints.down("xs")]: {
            "& .Cmt-header-root": {
                flexDirection: "column",
            },
            "& .Cmt-action-default-menu": {
                marginLeft: 0,
                marginTop: 10,
            },
        },
    },
    cardContentRoot: {
        padding: 0,
    }
}));

const TicketsContainer = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { ticketsStatus } = useSelector(({ tickets }) => tickets);

    useEffect(() => {
        dispatch(TicketRequests.getAllTickets(1, ticketsStatus));
    }, [ticketsStatus]);

    return (
        <CmtCard className={classes.cardRoot}>
            <CmtCardContent className={classes.cardContentRoot}>
                <TicketsTable />
            </CmtCardContent>
        </CmtCard>
    );
};

export default TicketsContainer;
